export async function GetEnableForms(thiss) {
  let Parameters = {
    params: {
      UserID: thiss.currentUser.UserID,
      Platform: "Magynet"
    }
  };
  let TableData = [];

  await thiss.$http
    .get("/api/survey/GetEnableFormsByUser", Parameters)
    .then((response) => {
      let data = response.data;
      TableData = data;
    });
  return TableData;
}

export const SurveyColumns = [];
